import getOr from 'lodash/fp/getOr';
import fr from '../i18n/fr.json';

const translations = JSON.parse(JSON.stringify(fr));

export const translate = (key: string): string => {
  return getOr(key, key, translations);
};
